// extracted by mini-css-extract-plugin
export var resizer = "_di-0";